"use client";

import useSWR from "swr";
import { getPage } from "../sanity/client";
import styles from "./therapy.module.css";
import CustomContent from "../components/customContent";

export default function Therapy() {
  const { data: content } = useSWR("page-therapy", () =>
    getPage("therapy").then((r) => r[0].content)
  );

  return (
    <>
      <h1 className="font-bold text-3xl mb-4">Therapy</h1>
      <div className={styles.therapyContent}>
        <CustomContent value={content} />
      </div>
    </>
  );
}
